import React from 'react'
import { CurrencyList } from '../../pages/Hub/Plans/Positions/Edit/types'

type Props = {
    value: string
    onChange: (value: number) => void
    currencyData: CurrencyList[]
}

const CurrencySelector: React.FC<Props> = ({
    value,
    onChange,
    currencyData,
}) => {
    return (
        <>
            <span className="form-label">Валюта договора</span>
            <select
                className="form-select h-full"
                onChange={(e) => onChange(Number(e.target.value))}
                value={value}
            >
                {currencyData.map((currency) => (
                    <option key={currency.num_code} value={currency.num_code}>
                        {currency.name}
                    </option>
                ))}
            </select>
        </>
    )
}

export default CurrencySelector
